import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Popover from '@rio-cloud/rio-uikit/Popover';
import { useEffect } from 'react';

import { config } from '../../config';
import { ServiceInfoPopover } from './ServiceInfoPopover';
import {
    hasServiceInfoSearchParamsState,
    shouldShowServiceInfoPopover,
    useServiceInfoSearchParams,
} from './serviceInfoSearchParams';

const ServiceInfo = () => {
    const applicationName = config.applicationName;
    const { searchParams, showServiceInfo, hideServiceInfo } = useServiceInfoSearchParams();
    const showPopover = shouldShowServiceInfoPopover(searchParams);

    useEffect(() => {
        if (showPopover && !hasServiceInfoSearchParamsState(searchParams)) {
            showServiceInfo();
        }
    }, [searchParams, showPopover, showServiceInfo]);

    const title = (
        <div>
            <span>{applicationName}</span>
            <span className={'text-color-gray margin-left-10'}>{config.releaseVersion}</span>
        </div>
    );

    const handleTogglePopover = (show: boolean) => {
        if (show) {
            showServiceInfo();
        } else {
            hideServiceInfo();
        }
    };

    const popover = (
        <Popover
            id='serviceInfo'
            style={{ width: 250 }}
            title={title}
            titleClassName='ActionBarItemPopover text-color-dark'
            contentClassName='ActionBarItemPopover'
        >
            <div className='ActionBarItemPopoverContent'>
                <ServiceInfoPopover />
            </div>
        </Popover>
    );

    return (
        <div className='ActionBarItem'>
            <OverlayTrigger
                show={showPopover}
                onToggle={handleTogglePopover}
                placement={OverlayTrigger.BOTTOM_END}
                overlay={popover}
                rootClose
                trigger='click'
                popperConfig={{
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 5],
                            },
                        },
                        {
                            name: 'arrow',
                            options: {},
                        },
                    ],
                }}
            >
                <div className='ActionBarItemIcon'>
                    <span className='icon rioglyph rioglyph-info-sign' data-testid={'service-info-button'} />
                </div>
            </OverlayTrigger>
        </div>
    );
};

export default ServiceInfo;
